import { Component, Input, Inject } from '@angular/core';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-create-voucher-posting-view',
  templateUrl: './create-voucher-posting-view.component.html',
  styleUrls: ['./create-voucher-posting-view.component.scss']
})
export class CreateVoucherPostingViewComponent {
  @Input()
  postData: any;
  voucherData: any = {};
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { postData: any },
    private apiService: ApiService,
  ) {
    this.fetchVoucherPostingData();
  }
  fetchVoucherPostingData() {
    this.apiService.voucherpostingview(this.data.postData).subscribe(
      (response) => {
        this.voucherData = response.posting || {};
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
